// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================
   BREAKPOINTS
============================ */
/* ============================
   HELPERS
============================ */
/* 🌐 Blog Section */
.blog-section {
  max-width: 1400px;
  margin: 0 auto;
  padding: 100px 0;
  text-align: center;
  /* RESPONSIVE PADDING */
}
@media (max-width: 1200px) {
  .blog-section {
    padding: 80px 2rem;
  }
}
@media (max-width: 992px) {
  .blog-section {
    padding: 70px 1.5rem;
  }
}
@media (max-width: 768px) {
  .blog-section {
    padding: 60px 1rem;
  }
}
@media (max-width: 576px) {
  .blog-section {
    padding: 50px 0.75rem;
  }
}
@media (max-width: 480px) {
  .blog-section {
    padding: 40px 0.5rem;
  }
}
.blog-section {
  /* TITLE */
}
.blog-section .blog-title {
  font-size: clamp(1.4rem, 4vw, 2.2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: 2rem;
}
@media (max-width: 768px) {
  .blog-section .blog-title {
    font-size: clamp(1.3rem, 5vw, 1.9rem);
  }
}
@media (max-width: 576px) {
  .blog-section .blog-title {
    font-size: clamp(1.2rem, 6vw, 1.6rem);
    margin-bottom: 1rem;
  }
}
@media (max-width: 480px) {
  .blog-section .blog-title {
    font-size: clamp(1.1rem, 7vw, 1.4rem);
    margin-bottom: 0.5rem;
  }
}
.blog-section {
  /* GRID */
}
.blog-section .blog-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;
  margin: 0 auto;
}
@media (max-width: 992px) {
  .blog-section .blog-container {
    gap: 2rem;
  }
}
@media (max-width: 768px) {
  .blog-section .blog-container {
    max-width: 600px;
    gap: 1.5rem;
  }
}
@media (max-width: 576px) {
  .blog-section .blog-container {
    grid-template-columns: 1fr;
    max-width: 400px;
  }
}
.blog-section {
  /* CARD */
}
.blog-section .blog-card {
  width: 100%;
  max-width: 350px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.blog-section .blog-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
}
.blog-section .blog-card img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
@media (max-width: 576px) {
  .blog-section .blog-card img {
    height: 180px;
  }
}
.blog-section .blog-card__content {
  padding: 1.5rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.blog-section .blog-card__content h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e2150;
  line-height: 1.3;
}
.blog-section .blog-card__content p {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.6;
  flex: 1 1;
}
.blog-section .blog-card__content .read-more {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #1e2150;
  font-weight: 600;
  cursor: pointer;
  padding: 0.5rem 0;
  transition: color 0.2s ease, transform 0.2s ease;
}
.blog-section .blog-card__content .read-more__icon {
  transition: transform 0.2s ease;
}
.blog-section .blog-card__content .read-more:hover {
  color: rgb(27, 29.7, 72);
  transform: translateX(2px);
}
.blog-section .blog-card__content .read-more:hover .read-more__icon {
  transform: translateX(4px);
}

/* MODAL OVERLAY */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* MODAL */
.modal {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}
.modal h3 {
  font-size: 1.2rem;
  color: #1e2150;
  margin-bottom: 1rem;
}
.modal p {
  font-size: 1rem;
  line-height: 1.7;
  color: #111827;
}`, "",{"version":3,"sources":["webpack://./src/styles/styleHomePage/blog.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;;8BAAA;AAsBA;;8BAAA;ADpBA,oBAAA;AACA;EACE,iBE8BU;EF7BV,cAAA;EACA,gBAAA;EACA,kBAAA;EAEA,uBAAA;AAGF;ACEI;EDXJ;IAQI,kBAAA;EAKF;AACF;ACHI;EDXJ;IAYI,oBAAA;EAMF;AACF;ACRI;EDXJ;IAgBI,kBAAA;EAOF;AACF;ACbI;EDXJ;IAoBI,qBAAA;EAQF;AACF;AClBI;EDXJ;IAwBI,oBAAA;EASF;AACF;AAlCA;EA2BE,UAAA;AAUF;AATE;EACE,qCAAA;EACA,gBAAA;EACA,cEnBS;EFoBT,mBEMS;AFKb;AChCI;EDiBF;IAOI,qCAAA;EAYJ;AACF;ACrCI;EDiBF;IAWI,qCAAA;IACA,mBEHO;EFgBX;AACF;AC3CI;EDiBF;IAgBI,qCAAA;IACA,qBETO;EFuBX;AACF;AA5DA;EAiDE,SAAA;AAcF;AAbE;EACE,aAAA;EACA,2DAAA;EACA,qBAAA;EACA,cAAA;AAeJ;AC1DI;EDuCF;IAOI,SAAA;EAgBJ;AACF;AC/DI;EDuCF;IAWI,gBAAA;IACA,WAAA;EAiBJ;AACF;ACrEI;EDuCF;IAgBI,0BAAA;IACA,gBAAA;EAkBJ;AACF;AAtFA;EAuEE,SAAA;AAkBF;AAjBE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBEhCQ;EFiCR,gBAAA;EACA,0CE7BY;EF8BZ,aAAA;EACA,sBAAA;EACA,qDAAA;AAmBJ;AAjBI;EACE,2BAAA;EACA,2CAAA;AAmBN;AAhBI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AAkBN;AClGI;ED6EA;IAMI,aAAA;EAmBN;AACF;AAhBI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAkBN;AAhBM;EACE,iBAAA;EACA,gBAAA;EACA,cEhGK;EFiGL,gBAAA;AAkBR;AAfM;EACE,kBAAA;EACA,WE3FK;EF4FL,gBAAA;EACA,SAAA;AAiBR;AAdM;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,cElHK;EFmHL,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gDAAA;AAgBR;AAdQ;EACE,+BAAA;AAgBV;AAbQ;EACE,wBAAA;EACA,0BAAA;AAeV;AAZQ;EACE,0BAAA;AAcV;;AAPA,kBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAUF;;AAPA,UAAA;AACA;EACE,gBAAA;EACA,mBEvHU;EFwHV,aAAA;EACA,gBAAA;EACA,WAAA;EACA,2CAAA;AAUF;AARE;EACE,iBAAA;EACA,cE/JS;EFgKT,mBAAA;AAUJ;AAPE;EACE,eAAA;EACA,gBAAA;EACA,cE7JG;AFsKP","sourcesContent":["@use \"sass:color\";\r\n@use \"../mixins\" as m;\r\n@use \"../variables\" as v;\r\n\r\n/* 🌐 Blog Section */\r\n.blog-section {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n  padding: 100px 0;\r\n  text-align: center;\r\n\r\n  /* RESPONSIVE PADDING */\r\n  @include m.respond(xl) {\r\n    padding: 80px 2rem;\r\n  }\r\n\r\n  @include m.respond(lg) {\r\n    padding: 70px 1.5rem;\r\n  }\r\n\r\n  @include m.respond(md) {\r\n    padding: 60px 1rem;\r\n  }\r\n\r\n  @include m.respond(sm) {\r\n    padding: 50px 0.75rem;\r\n  }\r\n\r\n  @include m.respond(xs) {\r\n    padding: 40px 0.5rem;\r\n  }\r\n\r\n  /* TITLE */\r\n  .blog-title {\r\n    font-size: clamp(1.4rem, 4vw, 2.2rem);\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n    margin-bottom: v.$spacing-lg;\r\n\r\n    @include m.respond(md) {\r\n      font-size: clamp(1.3rem, 5vw, 1.9rem);\r\n    }\r\n\r\n    @include m.respond(sm) {\r\n      font-size: clamp(1.2rem, 6vw, 1.6rem);\r\n      margin-bottom: v.$spacing-md;\r\n    }\r\n\r\n    @include m.respond(xs) {\r\n      font-size: clamp(1.1rem, 7vw, 1.4rem);\r\n      margin-bottom: v.$spacing-sm;\r\n    }\r\n  }\r\n\r\n  /* GRID */\r\n  .blog-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n    justify-items: center;\r\n    margin: 0 auto;\r\n\r\n    @include m.respond(lg) {\r\n      gap: 2rem;\r\n    }\r\n\r\n    @include m.respond(md) {\r\n      max-width: 600px;\r\n      gap: 1.5rem;\r\n    }\r\n\r\n    @include m.respond(sm) {\r\n      grid-template-columns: 1fr;\r\n      max-width: 400px;\r\n    }\r\n  }\r\n\r\n  /* CARD */\r\n  .blog-card {\r\n    width: 100%;\r\n    max-width: 350px;\r\n    background: #fff;\r\n    border-radius: v.$radius-md;\r\n    overflow: hidden;\r\n    box-shadow: v.$shadow-medium;\r\n    display: flex;\r\n    flex-direction: column;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n\r\n    &:hover {\r\n      transform: translateY(-6px);\r\n      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);\r\n    }\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 220px;\r\n      object-fit: cover;\r\n\r\n      @include m.respond(sm) {\r\n        height: 180px;\r\n      }\r\n    }\r\n\r\n    &__content {\r\n      padding: 1.5rem;\r\n      text-align: left;\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0.75rem;\r\n\r\n      h3 {\r\n        font-size: 1.1rem;\r\n        font-weight: 700;\r\n        color: v.$brand-blue;\r\n        line-height: 1.3;\r\n      }\r\n\r\n      p {\r\n        font-size: 0.95rem;\r\n        color: v.$text-muted;\r\n        line-height: 1.6;\r\n        flex: 1;\r\n      }\r\n\r\n      .read-more {\r\n        align-self: flex-start;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        background: none;\r\n        border: none;\r\n        color: v.$brand-blue;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        padding: 0.5rem 0;\r\n        transition: color 0.2s ease, transform 0.2s ease;\r\n\r\n        &__icon {\r\n          transition: transform 0.2s ease;\r\n        }\r\n\r\n        &:hover {\r\n          color: color.scale(v.$brand-blue, $lightness: -10%);\r\n          transform: translateX(2px);\r\n        }\r\n\r\n        &:hover .read-more__icon {\r\n          transform: translateX(4px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* MODAL OVERLAY */\r\n.modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n/* MODAL */\r\n.modal {\r\n  background: #fff;\r\n  border-radius: v.$radius-md;\r\n  padding: 2rem;\r\n  max-width: 600px;\r\n  width: 100%;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\r\n\r\n  h3 {\r\n    font-size: 1.2rem;\r\n    color: v.$brand-blue;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  p {\r\n    font-size: 1rem;\r\n    line-height: 1.7;\r\n    color: v.$dark;\r\n  }\r\n}\r\n","@use \"./variables\" as v;\r\n\r\n/* ============================\r\n   BREAKPOINTS\r\n============================ */\r\n$breakpoints: (\r\n        xs: 480px,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px,\r\n        xxl: 1400px\r\n);\r\n\r\n@mixin respond($bp) {\r\n  @if map-has-key($breakpoints, $bp) {\r\n    @media (max-width: map-get($breakpoints, $bp)) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @warn \"No breakpoint found: #{$bp}\";\r\n  }\r\n}\r\n\r\n/* ============================\r\n   HELPERS\r\n============================ */\r\n@mixin flex-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@mixin truncate-text($lines: 1) {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: $lines;\r\n  -webkit-box-orient: vertical;\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
